import { FC, useContext, useEffect } from "react";

import { BoardContext, PhaseContext, SocketContext, TableContext, TeamContext, UserContext } from "../../../context";
import { BluredBlueModal, FirstPersonViewUserImage, FocusButton, MainButton, NextButton } from "../../atoms";
import { 
    BoardMolecule, 
    StrengthCardsHolder, 
    GameBoardHeader, 
    CardsInHandMolecule, 
    InitialDeckScreen, 
    WheelOfFortuneMolecule, 
    VoteToThrowAUserOutModal, 
    SolutionDecksHolder, 
    Modal, 
    BoardChat, 
    StrengthCardsToggleArrow, 
    GameWinnersPodium, 
    AlertBox,
    StartIntroductionOrSkip,
    PlayerMiniProfile,
    DilemmaOwnerAnouncement,
    SideOptionFacilitator
} from "../../molecules";
import { RenderInitialDisplay } from "../../molecules/Board/subBoardComponents";
import { BoardTableEllipse, ChosenDilemmaFullScreen } from "../../organisms";


import { useBoardDisplayView, useHandsState, useIsAnyUserLoggedOut } from "../../../hooks";
import { Phase } from "../../../util/enums";
import DilemmaOwnerCoinCelebration from "../CelebrationTemplate/DilemmaOwnerCoinCelebration";
import RenderSelectedCardsCelebration from "../CelebrationTemplate/RenderSelectedCardsCelebration";
import GrandCoinCelebratoin from "../CelebrationTemplate/GrandCoinCelebratoin";
import MySolutionCardsFullScreen from "../FullScreens/MySolutionCardsFullScreen";
import ChoosingProposedSolutionCardsFullScreen from "../FullScreens/ChoosingProposedSolutionCardsFullScreen";
import DilemmaAndPickedSolutionCards from "../FullScreens/DilemmaAndPickedSolutionCards";
import StrengthCardsAreShownFullScreen from "../FullScreens/StrengthCardsAreShownFullScreen";
import ChosenActionFullScreen from "../FullScreens/ChosenActionFullScreen";
import RoundsTransitionFullScreen from "../FullScreens/RoundsTransitionFullScreen";
import TippingSecionAnoncement from "../FullScreens/TippingSecionAnoncement";
import ProgressBar from "../../atoms/Display/ProgressBar/ProgressBar";
import { useTranslation } from "react-i18next";

const Board: FC<{}> = () => {
    const { t } = useTranslation();
    const { finishIntroductionSocketEvent, theSolutionCardSelectedByDilemmaOwner } = useContext(SocketContext);
    const { game } = useContext(TeamContext);
    const { userData } = useContext(UserContext);
    const { 
        isInitialSolutionDecksModalOpen, 
        renderDilemmaCardsInThisPhase,
        displayModalData, 
        renderInitialCoins,
        setDisplayModalData,
        areSolutionCardsDrawnContext,
        isStrengthCardsComponentShown,
        isWinnersPodiumShown,
        areYouSureBoxRendered,
        instructionTutorial,
        setInstructionTutorial,
        isDilemmaOwnerAnouncementDone,
        isCurrentlyPhase16,
        setIsCurrentlyPhase16,
        areStrengthsShownFullScreen
    } = useContext(BoardContext);
    const { renderChosenSolutionToQuestion, dilemmaOwnerCoinCelebration, renderWheelOfFortune } = useContext(PhaseContext);
    const { isDilemmaChosen, toggleMySolutionFullScreen } = useContext(TableContext);
    const isTheUserDilemaOwner = userData?.email === game?.gameInfo.currentPlayerEmail;
    const [ challengeCard, displayView, drawChallengeCard] = useBoardDisplayView();
    useHandsState(isTheUserDilemaOwner);
    // usePhasesUpdates();
    const [isAnyUserCurrentlyLoggedOut, listOfTheUsersWhoLoggedout] = useIsAnyUserLoggedOut();
    const zIndexForPhaseThree : boolean = game?.phase === Phase.CHOOSING_SOLUTION_CARDS && !areSolutionCardsDrawnContext;
    const zIndexForPhaseFour : boolean = game?.phase === Phase.PICK_DILEMMA && isTheUserDilemaOwner;
	const zIndexForOtherBluredBluePhases : boolean = game?.phase === Phase.SOLUTION_CHOSEN ||  game?.phase === Phase.SOLUTION_CHOSEN_REWARD || game?.phase === Phase.RENDER_SPIN_WHEEL;
	const zIndexPerPhase : number = (zIndexForPhaseThree || zIndexForPhaseFour || zIndexForOtherBluredBluePhases || isWinnersPodiumShown) ? 1 : 20;
    const zIndexPerPhaseForStrengthCards : number = (zIndexForPhaseThree || zIndexForPhaseFour || zIndexForOtherBluredBluePhases || isWinnersPodiumShown || game?.phase === Phase.CHOOSE_SOLUTION || game?.phase === Phase.PICK_DILEMMA || game?.phase === Phase.CONFETTI_CELEBRATION) ? 1 : 51;
    const numberOfSolvedDilemmas: number = game?.gameInfo.challengeScore || 0;

    const windowLocationHref = window.location.href;

    const isSpectator : boolean = windowLocationHref.includes("spectator");

    const isCheeringCelebration = game?.phase === Phase.CONFETTI_CELEBRATION;

    const displayDilemmaCard = () => {
        return (
            <BluredBlueModal>
                <div className="emptyclass">
                    <div style={{ zIndex: 2, position: 'relative' }}>
                        <RenderInitialDisplay challengeCard={challengeCard} comfirmActionCardParent={(a: any, b: any) => drawChallengeCard(a, b!)} />
                    </div>
                </div>
            </BluredBlueModal>
        );
    }

    const displayInitialSolutionCardDecks = () => {
        return (
            <div className={` ${areSolutionCardsDrawnContext ? "display_none" : ""} `}>
                <BluredBlueModal fullDarkBackground={true}>
                    <div className="emptyclass">
                        <div style={{ zIndex: 2, position: 'relative' }}>
                            <InitialDeckScreen />
                        </div>
                    </div>
                </BluredBlueModal>
            </div>
        );
    }

    useEffect(() => {
        const timeout = setTimeout(() => {
            setInstructionTutorial("x");
            finishIntroductionSocketEvent();
            setIsCurrentlyPhase16(false);
        }, 60000 ); 

        return () => clearTimeout(timeout);
        
    },[]);

    const finishInstructions = () => {
        setInstructionTutorial("");
        finishIntroductionSocketEvent();
    }

    const displayLetsPlayButton = () => {
        return (
            <div className="full_screen_vw_vh center_horizontally_and_vertically" style={{position: "absolute", zIndex: 22}}>
                <ProgressBar totalProgress = {10} progressNumber = {3} ></ProgressBar>
                <div className="lets_play_button_wrapper">
                    <MainButton text={t("letsPlayText")} type="big" clickHandler={() => finishInstructions() }  />
                </div>
            </div>
        )
    }

    const displayChosenSolutionToQuestion = () => {
        return (
            <BluredBlueModal>
                <RenderSelectedCardsCelebration />
            </BluredBlueModal>
        )
    }

    const displayChosenSolutionToQuestionCoinCelebration = () => {
        return (
            <BluredBlueModal>
                <DilemmaOwnerCoinCelebration />
            </BluredBlueModal>
        )
    }

    const displayAlertBox = () => {
        return (
            <div style={{zIndex: 50}}>
                <BluredBlueModal>
                    <AlertBox />
                </BluredBlueModal>
            </div>
        )
    }

    const displayWheelOfFortune = () => {
        return (
            <BluredBlueModal>
                <div className="emptyclass overflow_hidden_full_browser_screen" style={{position: "absolute"}} >
                    <div style={{ zIndex: 2, position: 'relative' }}>
                        <WheelOfFortuneMolecule />
                    </div>
                </div>
            </BluredBlueModal>
        );
    }

    const displayScreenWhenSomeUserLoggesOut = () => {
        return (
            <div className="emptyclass">
                <div style={{ zIndex: 51, position: 'relative' }}>
                    <VoteToThrowAUserOutModal dataOfTheUserWhoLoggedOut={listOfTheUsersWhoLoggedout} />
                </div>
            </div>
        );
    }

    const displayWinnerPodium = () => {
        return <GameWinnersPodium />;
    }

    return (
        <div className="board_wrapper">

            <BoardMolecule />
            <GameBoardHeader />
            { (isTheUserDilemaOwner || instructionTutorial === "leftSideOfTheScreen") && <div> <StrengthCardsHolder  zIndexPerPhase={zIndexPerPhase} /> </div> }
            { (!isTheUserDilemaOwner && isStrengthCardsComponentShown) && <div> <StrengthCardsHolder zIndexPerPhase={zIndexPerPhaseForStrengthCards} /> </div> }
            { !isTheUserDilemaOwner && instructionTutorial !== "leftSideOfTheScreen" && <StrengthCardsToggleArrow zIndexPerPhase={zIndexPerPhaseForStrengthCards} /> }
            <BoardTableEllipse />
            <SolutionDecksHolder /> 
            <FirstPersonViewUserImage />
            {instructionTutorial === "solutionCards" && <div style={{position: "relative", zIndex: 50}} className="board_wrapper">
                <div className="introduciton_blured_background_behind_hands"> hello </div>
                <CardsInHandMolecule />
            </div>}
            {instructionTutorial !== "solutionCards" && <CardsInHandMolecule />}
            <BoardChat />
            <FocusButton />
            
            {displayModalData && <Modal close={() => setDisplayModalData(undefined)} chosenSolutions={displayModalData.solutionCombinationsForThisCard} selectedStrengthCard={displayModalData.card}/>}
            
            {isInitialSolutionDecksModalOpen && displayInitialSolutionCardDecks()}
            {renderInitialCoins && <GrandCoinCelebratoin />}

            
            {renderChosenSolutionToQuestion && displayChosenSolutionToQuestion()}
            {dilemmaOwnerCoinCelebration && displayChosenSolutionToQuestionCoinCelebration()}
            {renderWheelOfFortune && displayWheelOfFortune()}
            {areYouSureBoxRendered.isBoxActive && displayAlertBox()}

            {/* {isAnyUserCurrentlyLoggedOut && displayScreenWhenSomeUserLoggesOut()} */}
            {isCurrentlyPhase16 && <StartIntroductionOrSkip />}
            {(instructionTutorial === "solutionCards" || instructionTutorial === "leftSideOfTheScreen") && <NextButton />}
            {instructionTutorial === "leftSideOfTheScreen" && <div style={{position: "absolute", top: "2vh", left: 0, zIndex: 25}}> <PlayerMiniProfile showNotification={true} /> </div> }
            {instructionTutorial === "rightSideOfTheScreen" && displayLetsPlayButton()}
        

            {game?.phase === Phase.PICK_DILEMMA && renderDilemmaCardsInThisPhase && !isDilemmaOwnerAnouncementDone && <RoundsTransitionFullScreen /> } 
            {game?.phase === Phase.PICK_DILEMMA && renderDilemmaCardsInThisPhase && isDilemmaOwnerAnouncementDone === "dilemmaOwnerAnouncement" && <DilemmaOwnerAnouncement />}
            {game?.phase === Phase.PICK_DILEMMA && renderDilemmaCardsInThisPhase && isDilemmaOwnerAnouncementDone === "renderDilemmaCard" && displayDilemmaCard()}
            {game?.phase === Phase.QUESTION_CARD && !isDilemmaChosen && <ChosenDilemmaFullScreen /> }
            {game?.phase === Phase.QUESTION_CARD && isDilemmaChosen && !isTheUserDilemaOwner && toggleMySolutionFullScreen && <MySolutionCardsFullScreen /> }
            {game?.phase === Phase.CHOOSE_SOLUTION && !theSolutionCardSelectedByDilemmaOwner && <ChoosingProposedSolutionCardsFullScreen />}
            {game?.phase === Phase.CHOOSE_SOLUTION && !theSolutionCardSelectedByDilemmaOwner && isDilemmaOwnerAnouncementDone === "renderTippingHeart" && numberOfSolvedDilemmas === 1 && <TippingSecionAnoncement />}
            {game?.phase === Phase.CHOOSE_SOLUTION && theSolutionCardSelectedByDilemmaOwner  && !areStrengthsShownFullScreen && <DilemmaAndPickedSolutionCards />}
            {game?.phase === Phase.CHOOSE_SOLUTION && theSolutionCardSelectedByDilemmaOwner  && areStrengthsShownFullScreen  && <StrengthCardsAreShownFullScreen />}

            {game?.phase === Phase.ACTION_CARD && <ChosenActionFullScreen /> }

            {isSpectator && <SideOptionFacilitator />}

            {isWinnersPodiumShown && displayWinnerPodium()} 
           
            <canvas id="confeti-random" style={{ position: 'absolute', top: '0', width: '90%', height: '99%', zIndex: isCheeringCelebration ? 71 : -1 }} />
        </div>
    );
};

export default Board;